import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import KitchenStatusActions from '../actionCreators/KitchenStatusActions';

const useStripeConfig = ({ fetchOnMount = true } = {}) => {
  const dispatch = useDispatch();

  const {
    kitchen,
    publishableKey,
    loading,
    error,
    stripeConfigIdentifier,
    stripeConfigStatus,
  } = useSelector((state) => ({
    kitchen: get(state.locationReducer, 'kitchen'),
    publishableKey: get(state.paymentUIReducer, 'stripePublishableKey'),
    loading: get(state.paymentUIReducer, 'stripeKeyLoading'),
    error: get(state.paymentUIReducer, 'stripeKeyError'),
    stripeConfigIdentifier: get(state.paymentUIReducer, 'stripeConfigIdentifier'),
    stripeConfigStatus: get(state.paymentUIReducer, 'stripeConfigStatus'),
  }));

  const kitchenIdentifier = get(kitchen, 'id') || get(kitchen, 'slug');

  useEffect(() => {
    if (!fetchOnMount) {
      return;
    }

    if (!kitchenIdentifier) {
      return;
    }

    if (loading) {
      return;
    }

    const alreadyFetchedForKitchen = stripeConfigIdentifier === kitchenIdentifier;

    if (alreadyFetchedForKitchen) {
      if (stripeConfigStatus === 'loading' || stripeConfigStatus === 'success' || stripeConfigStatus === 'error') {
        return;
      }
    }

    const request = dispatch(KitchenStatusActions.kitchenStripeConfigLoad(kitchenIdentifier));

    if (request && typeof request.catch === 'function') {
      request.catch(() => {});
    }
  }, [dispatch, fetchOnMount, kitchenIdentifier, loading, stripeConfigIdentifier, stripeConfigStatus]);

  const effectiveKey = publishableKey;
  const ready = Boolean(effectiveKey);

  return {
    publishableKey: effectiveKey,
    loading,
    error,
    ready,
    kitchen,
    kitchenIdentifier,
  };
};

export default useStripeConfig;
